// Tracks which onboarding nudges the user has dismissed.
// Persisted to localStorage so they never reappear after dismissal.

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type NudgeId =
  | 'bankroll_setup'    // shown when bankrollSettings === null
  | 'module_activate'   // shown after bankroll set, before first rec
  | 'first_rec';        // shown when first STRONG_BET rec arrives

interface OnboardingState {
  dismissed: Partial<Record<NudgeId, boolean>>;
  dismissNudge: (id: NudgeId) => void;
  isDismissed: (id: NudgeId) => boolean;
  resetAll: () => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist<OnboardingState>(
    (set, get) => ({
      dismissed: {},
      dismissNudge: (id) => set((s) => ({ dismissed: { ...s.dismissed, [id]: true } })),
      isDismissed: (id) => get().dismissed[id] === true,
      resetAll: () => set({ dismissed: {} }),
    }),
    {
      name: 'navyrx-onboarding',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
